angular.module('impactx.search').controller('SearchListProductInfiniteCtrl', SearchListProductInfiniteController);

SearchListProductInfiniteController.$inject = [
    '$scope',
    'searchFilter',
    'AddToBasketService',
    'SearchService',
    '$redirect',
    '$context',
    'ProductViewService',
    '$routeParams',
    'sidebarShow',
    'dataGen',
    'panelService',
    '$location',
    'TranslationService',
    'productComparison',
    'FavoritesService',
    'ProductImageGalleryService',
    'AppConfiguration'];

function SearchListProductInfiniteController($scope, searchFilter, AddToBasketService, SearchService, $redirect, $context,
                                             ProductViewService, $routeParams, sidebarShow, dataGen, panelService, $location,
                                             TranslationService, productComparison, FavoritesService, ProductImageGalleryService,
                                             AppConfiguration) {
    $scope.topIndexVirtualRepeat = {value: 0};
    $scope.currentPage = {value: 1};
    $scope.fetchInProgress = {value: false};
    $scope.fetchMoreInProgress = {value: false};
    $scope.fetchLessInProgress = {value: false};
    this.hideSearchInput = true;
    searchFilter.currentPage = searchFilter.pageSearchProduct;
    var vm = this;
    vm.searchGrid = false;

    vm.numberOfAttributes = 3;
    vm.sidebarShow = sidebarShow;
    $scope.cachedProcurementGroup = {};
    $scope.hasActiveThemeWorld = $context.hasActiveThemeWorldSearch.value;
    $scope.hasSearchInput = !!searchFilter.searchInput;
    $scope.recentSearchText = searchFilter.searchInput;

    vm.toggleAll = function () {
        if (vm.numberOfAttributes < 0) {
            vm.numberOfAttributes = 3;
        }
        else {
            vm.numberOfAttributes = -1;
        }
    };

    vm.facetResults = [];
    vm.getProductPanelColor = panelService.getProductPanelColor;

    this.updateFilterData = function () {
        $scope.filters = [];
        $scope.filters.push(searchFilter.getSearchFilterData().tenderId);
        $scope.filters.push(searchFilter.getSearchFilterData().lotId);
        $scope.filters.push(searchFilter.getSearchFilterData().vcatalogId);
        $scope.filters.push(searchFilter.getSearchFilterData().supplierId);
        $scope.filters.push(searchFilter.getSearchFilterData().manufacturerId);
        angular.forEach($scope.filters, function (filter) {
            if (filter.stringValue) {
                $scope.hasActiveFilter = true;
            }
        });

        $scope.fixedFilters = searchFilter.getSearchFilterData();
        $scope.searchFilter = searchFilter;
        var attributeSearch = $scope.data.searchResults.attributeSearch;
        vm.numberOfProducts = $scope.data.searchResults.numOfProducts;
        if (attributeSearch) {
            vm.facetResults = attributeSearch.facetResults;
            if (AppConfiguration.get('hasGuidingClassification') && attributeSearch.eclassFilter) {
                vm.eclassFilter = attributeSearch.eclassFilter;
                vm.eclassFilter.selectedItem = searchFilter.selectedEClass;
            }
        }
        else {
            vm.facetResults = [];
        }
    };

    var preLoadingNumber = 20;
    $scope.search = function () {
        $scope.recentSearchText = searchFilter.searchInput;
        var lastTopIndex = SearchService.consumableTopIndexProductSearch.value;
        SearchService.consumableTopIndexProductSearch.value = 0;
        var stepSize = 10;
        $scope.topIndexVirtualRepeat.value = lastTopIndex;
        $scope.currentPage.value = Math.floor(lastTopIndex / stepSize) + 1;

        SearchService.handleInfiniteProductSearch($scope, lastTopIndex, stepSize, preLoadingNumber, false, vm.updateFilterData, 0);
    };

    if ($routeParams.nosearch) {
        searchFilter.resetSearchFilter().then(function () {
            $scope.filters = [];
            $scope.fixedFilters = searchFilter.getSearchFilterData();
            $scope.searchFilter = searchFilter;
        });
    }
    else {
        $scope.search();
    }

    $scope.addToBasket = AddToBasketService.addToBasket;
    $scope.hasProducts = SearchService.hasProducts;

    vm.deleteFilter = function () {
        $scope.hasActiveFilter = false;
        searchFilter.getSearchFilterData().tenderId.stringValue = undefined;
        searchFilter.getSearchFilterData().lotId.stringValue = undefined;
        searchFilter.getSearchFilterData().vcatalogId.stringValue = undefined;
        searchFilter.getSearchFilterData().supplierId.stringValue = undefined;
        searchFilter.getSearchFilterData().manufacturerId.value = undefined;
        $redirect.redirectTo(null, "/search.product")
    };

    vm.isSelectable = function () {
        return $context.hasActiveProductView.value;
    };

    vm.reload = function () {
        $scope.search();
    };

    vm.toggleDrillDown = function (item) {
        searchFilter.toggleDrillDown(item);
        $scope.search();
    };
    vm.exists = searchFilter.exists;

    // Required.
    var DynamicItems = function () {
    };
    // Required.
    DynamicItems.prototype.getItemAtIndex = function (index) {
        return $scope.data.searchResults.products[index]
    };
    // Required.
    DynamicItems.prototype.getLength = function () {
        return $scope.data.searchResults.products.length;
    };
    $scope.showSearch = {value: true};

    vm.toggleSearch = function () {
        $scope.showSearch.value = !$scope.showSearch.value;
    };

    vm.addAllToProductView = function (event) {
        ProductViewService.addProductsToProductView(null, event, $scope.data.searchResults.numOfProducts);
    };

    $scope.searchTextClearFilter = function (classificationName) {
        searchFilter.getSearchFilterData().productGroupId = undefined;
        vm.eclassFilter = undefined;
        searchFilter.selectedEClass = undefined;
        searchFilter.searchInput = classificationName;
        $scope.hasSearchInput = true;
        $scope.search();
    };

    $scope.searchProductFamily = function (selected) {
        searchFilter.getSearchFilterData().procurementGroup.selected = null;
        searchFilter.getSearchFilterData().productFamily.selected = selected;
        $scope.search();
    };

    $scope.searchProcurementGroup = function (selected) {
        searchFilter.getSearchFilterData().procurementGroup.selected = selected;
        $scope.search();
    };

    $scope.nextLevel = function (selectedNode) {
        var forSearchList = $location.path().indexOf('search.product') > 0;
        return dataGen.getData({}, {
            prgId: selectedNode.id,
            forSearchList: forSearchList,
            filterIdentifier: 'search'
        }, "/search/filter/eclass", null, true).then(function (data) {
            if (impactX.isDefined(data, "data.items")) {
                return data.data.items;
            }
        });
    };

    $scope.selectedItemChange = function (selectedNode) {
        searchFilter.getSearchFilterData().productGroupId = impactX.isDefined(selectedNode, "id");
        searchFilter.selectedEClass = selectedNode;
        $scope.search();
    };

    $scope.redirectToDetails = function (product, index) {
        SearchService.lastTopIndexProductSearch.value = index;
        if (product.isCompilationArticle) {
            $redirect.redirectTo(null, "compilation/" + product.id);
        }
        else {
            // pass on the view the backend resolved for this product, so the catalog link in the
            // product details points back to that view instead of the original supplier catalog
            var targetVCatId = product.vcatalog ? product.vcatalog.id : null;
            if (targetVCatId) {
                $redirect.redirectTo(null, "productredirect/" + product.id + "/" + targetVCatId);
            }
            else {
                $redirect.redirectTo(null, "product/" + product.id);
            }
        }
    };

    vm.toProductComparison = function (pro) {
        if (pro.isUnite) {
            productComparison.addExternalProductToComparison(pro);
        } else {
            productComparison.addToComparison(pro.id);
        }
    };

    vm.addToFavorites = function (pro) {
        FavoritesService.add(pro);
        pro.isFavorite = true;
    };

    vm.removeFromFavorites = function (pro) {
        FavoritesService.remove(pro);
        pro.isFavorite = false;
    };

    $scope.compareAllowed = $context.$securityManager.isProcessAllowed("CompareProducts");
    $scope.favoritesAllowed = $context.$securityManager.isProcessAllowed("Favorite");

    vm.openImageGallery = function (event, product, index) {
        if (event) {
            event.stopPropagation();
        }

        fileExists(product.imageUrl).then(function () {
            ProductImageGalleryService.openGallery(event, product);

        }, function () {
            $scope.redirectToDetails(product, index);
        });
    };

    function fileExists(url) {
        return ProductImageGalleryService.imageExists(url);
    }

    var checkFilter = function(filter) {
        return !!(filter && (filter.value || filter.selected))
    };


    vm.anyFiltersSet = function() {
        var filterdata = $scope.fixedFilters;
        if(filterdata) {
            if (filterdata.drillDowns && filterdata.drillDowns.length > 0) {
                return true;
            }
            return !!searchFilter.searchInput
                || checkFilter(filterdata.supplier)
                || checkFilter(filterdata.manufacturer)
                || checkFilter(filterdata.contractNo)
                || checkFilter(filterdata.supplierNo)
                || checkFilter(filterdata.category)
                || checkFilter(filterdata.sort)
                || checkFilter(filterdata.priceRange.minValue)
                || checkFilter(filterdata.priceRange.maxValue);
        }
        return false;
    };
}